import React, { useEffect, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
// import required modules
import { Pagination, EffectCoverflow } from "swiper/modules";
import stadium from "../components/images/motera.webp";
const Loader = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="loader">
        {" "}
        <svg
          role="img"
          aria-label="Mouth and eyes come from 9:00 and rotate clockwise into position, right eye blinks, then all parts rotate and merge into 3:00"
          class="smiley"
          viewBox="0 0 128 128"
          width="128px"
          height="128px"
        >
          <defs>
            <clipPath id="smiley-eyes">
              <circle
                class="smiley__eye1"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(-40,64,64) translate(0,-56)"
              />
              <circle
                class="smiley__eye2"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(40,64,64) translate(0,-56)"
              />
            </clipPath>
            <linearGradient id="smiley-grad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#000" />
              <stop offset="100%" stop-color="#fff" />
            </linearGradient>
            <mask id="smiley-mask">
              <rect
                x="0"
                y="0"
                width="128"
                height="128"
                fill="url(#smiley-grad)"
              />
            </mask>
          </defs>
          <g
            stroke-linecap="round"
            stroke-width="12"
            stroke-dasharray="175.93 351.86"
          >
            <g>
              <rect
                fill="hsl(193,90%,50%)"
                width="128"
                height="64"
                clip-path="url(#smiley-eyes)"
              />
              <g fill="none" stroke="hsl(193,90%,50%)">
                <circle
                  class="smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />
                <circle
                  class="smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(0,64,64)"
                />
              </g>
            </g>
            <g mask="url(#smiley-mask)">
              <rect
                fill="hsl(223,90%,50%)"
                width="128"
                height="64"
                clip-path="url(#smiley-eyes)"
              />
              <g fill="none" stroke="hsl(223,90%,50%)">
                <circle
                  class="smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />
                <circle
                  class="smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(0,64,64)"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};
const stadiumImages = [
  {
    image: "https://www.iplt20.com/assets/images/stadiumimage/Chennai-new.jpg",
    name: "Chepauk Stadium",
    capacity: "33500",
  },
  {
    image: "https://www.iplt20.com/assets/images/stadiumimage/Narendra-new.jpg",
    name: "Narendra Modi Stadium",
    capacity: "110000",
  },
  {
    image:
      "https://www.iplt20.com/assets/images/stadiumimage/eden-garden-small-new.jpg",
    name: "Eden Gardens",
    capacity: "80000",
  },
  {
    image:
      "https://www.iplt20.com/assets/images/stadiumimage/Wankhede-Stadium-new.jpg",
    name: "Wankhede Stadium",
    capacity: "33108",
  },
  {
    image:
      "https://www.iplt20.com/assets/images/stadiumimage/M.Chinnaswamy-Stadium.jpg",
    name: "M. Chinnaswamy Stadium",
    capacity: "40000",
  },
  {
    image:
      "https://www.iplt20.com/assets/images/stadiumimage/Arun-Jaitley-Stadium-Delhi.jpg",
    name: "Arun Jaitley Stadium",
    capacity: "55000",
  },
  {
    image:
      "https://img-cdn.publive.online/fit-in/1200x675/betbarter/media/media_files/2025/02/28/Vr5vQ4CvOOXozsbHuerd.jpg",
    name: "Maharaja Yadavindra Singh International Cricket Stadium",
    capacity: "38000",
  },
  {
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Uppal_stadium_Rajiv_Gandhi_International_Cricket_Stadium.jpg/1280px-Uppal_stadium_Rajiv_Gandhi_International_Cricket_Stadium.jpg",
    name: "Rajiv Gandhi International Cricket Stadium",
    capacity: "55000",
  },
  {
    image:
      "https://logicalfantasytrick.com/wp-content/uploads/2025/04/Sawai-Mansingh-Stadium-Jaipur-2.jpg",
    name: "Sawai Mansingh Stadium",
    capacity: "24000",
  },
  {
    image: "https://static.toiimg.com/photo/103995682.cms",
    name: "Bharat Ratna Shri Atal Bihari Vajpayee Cricket Stadium",
    capacity: "50100",
  },

  // Add other images and names here
];
const Stadiums = () => {
  const [currentImage, setCurrentImage] = useState(stadiumImages[0].image);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const images = stadiumImages.map((stadium) => stadium.image);
    const promises = images.map((image) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = image;
        img.onload = () => resolve();
        img.onerror = () => resolve();
      });
    });

    Promise.all(promises)
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));

    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex relative justify-center items-center w-full h-screen">
          {/* Dynamic background */}
          <div
            className="absolute inset-0 bg-center bg-cover"
            style={{ backgroundImage: `url(${currentImage})` }}
          >
            {/* Semi-transparent overlay */}
            <div className="absolute inset-0 bg-black opacity-50"></div>
          </div>

          {/* Swiper Carousel */}
          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
            }}
            modules={[EffectCoverflow, Pagination]}
            pagination={{ clickable: true }}
            className="mySwiper landingPageSwiper w-[70%] overflow-hidden md:h-[500px] h-auto  flex md:flex-row flex-col items-center justify-center rounded-xl"
            onSlideChange={(swiper) => {
              // Update currentImage state when carousel slide changes
              setCurrentImage(stadiumImages[swiper.activeIndex].image);
            }}
          >
            {stadiumImages.map((stadium, index) => (
              <SwiperSlide key={index} className="w-full h-full">
                <img
                  src={stadium.image}
                  alt={`stadium-${index}`}
                  className="object-cover object-center w-full h-full"
                />
                <div className="absolute bottom-0 left-0 p-4 text-white bg-black bg-opacity-50">
                  {stadium.name}
                </div>
                <div className="absolute top-0 right-0 p-4 text-white bg-black bg-opacity-50">
                  Capacity : {stadium.capacity}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </>
  );
};

export default Stadiums;
